<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍品名称">{{info.name}}</a-form-item>
      <a-form-item label="封面图片">
        <img style="height: 40px" :src="API + info.thumb" alt="">
      </a-form-item>
      <a-form-item label="更多图片">
        <img v-for="(img, index) in info.imgs" :key="index" style="height: 40px; margin-right: 10px" :src="API + img.file_path" alt="">
      </a-form-item>
      <a-form-item label="赢家限量">{{info.winner_q}}</a-form-item>
      <a-form-item label="拍品编号">{{info.sn}}</a-form-item>
      <a-form-item label="起拍价">{{info.price}} 元</a-form-item>
      <a-form-item label="添加时间">{{info.created_at}}</a-form-item>
      <a-form-item label="说明信息">
        <div v-html="info.desc"></div>
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="update">编辑</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec {
  margin: 15px;
}
img {
  max-width: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      info: {},
    };
  },
  async created() {
    const id = this.$route.query.id;
    const r = await this.$axios.get("/tuanpai/goods/getInfo?id=" + id);
    if (r.status == 1) {
      this.info = r.info;
    }
  },
  methods: {
    update() {
      this.$router.push(`/tuanpai/goods/update?id=${this.info.id}`);
    },
  },
};
</script>